import {createSelector} from 'reselect';

const navigation = state => state.pageState?.explorerMap?.navigation;
const landingPage = state => state.pageState?.explorerMap?.landingPage;

export const getNavigation = createSelector(
    navigation,
    landingPage,
    (_navigation, _landingPage) => ({
        ..._navigation,
        key: _navigation.key || _landingPage || 'explore',
    })
);

export const getExplorerNavigation = createSelector(navigation, _navigation => ({
    ..._navigation,
    key: _navigation.key || 'explore',
}));
